import { render, staticRenderFns } from "./CopyLayoutModal.vue?vue&type=template&id=449c2d30"
import script from "./CopyLayoutModal.vue?vue&type=script&lang=js"
export * from "./CopyLayoutModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('449c2d30')) {
      api.createRecord('449c2d30', component.options)
    } else {
      api.reload('449c2d30', component.options)
    }
    module.hot.accept("./CopyLayoutModal.vue?vue&type=template&id=449c2d30", function () {
      api.rerender('449c2d30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/CopyLayoutModal.vue"
export default component.exports